import { Input } from '@chakra-ui/react'
import { AxiosError } from 'axios'
import { useEffect, useState } from 'react'

import { FormField } from '../../../../components/FormField'
import { FormModal } from '../../../../components/FormModal'
import { useAppToast } from '../../../../helpers'
import { ICourseInterface } from '../../../../interfaces/Website/Courses/CoursesCategory/ICoursesCategory'

interface ICategoryModalProps {
  isOpen: boolean
  onClose: () => void
  onFinished: () => void
  initialData?: { id: number; name: string } | null
  service: {
    create: (data: { name: string }) => Promise<ICourseInterface>
    update: (id: number, data: { name: string }) => Promise<ICourseInterface>
  }
}

export function CoursesCategoryModal({
  isOpen,
  onClose,
  onFinished,
  initialData = null,
  service
}: ICategoryModalProps) {
  const toast = useAppToast()
  const [name, setName] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  const isEditMode = !!initialData

  useEffect(() => {
    if (isOpen) {
      setName(initialData?.name || '')
      setError('')
    }
  }, [isOpen, initialData])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!name.trim()) {
      setError('O nome é obrigatório.')
      return
    }

    setSaving(true)
    setError('')

    try {
      if (isEditMode && initialData) {
        await service.update(initialData.id, { name: name.trim() })
        toast.success('Categoria atualizada com sucesso!')
      } else {
        await service.create({ name: name.trim() })
        toast.success('Categoria criada com sucesso!')
      }
      onFinished()
      handleClose()
    } catch (err: unknown) {
      const error = err as AxiosError<{ message: string; errors?: Record<string, string[]> }>
      toast.error('Não foi possível salvar a categoria de curso')
      if (error.response?.data?.errors?.name) {
        setError(error.response?.data?.errors?.name[0])
      }
    } finally {
      setSaving(false)
    }
  }

  const handleClose = () => {
    setName('')
    setError('')
    onClose()
  }

  return (
    <FormModal
      isOpen={isOpen}
      onClose={handleClose}
      title={isEditMode ? 'Editar Categoria de Curso' : 'Adicionar Nova Categoria'}
      onSubmit={handleSubmit}
      size="compact"
      isLoading={saving}
    >
      <FormField label="Nome da categoria" error={error}>
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Digite o nome da categoria"
          isDisabled={saving}
          autoFocus
        />
      </FormField>
    </FormModal>
  )
}
